import { Link } from 'react-router-dom';
import { getPosterUrl } from '@/mocks/imageUrls';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={getPosterUrl('hero-bg')}
          alt="奇优影院 - 最新电影与电视剧高清在线观看"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950/95"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/40 via-transparent to-background-950/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6 py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 border border-primary-500/30 rounded-full mb-8">
          <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
          <span className="text-primary-400 text-sm font-medium whitespace-nowrap">每日更新 · 高清画质 · 流畅不卡顿</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mb-6 leading-tight">
          奇优影院
          <span className="block text-foreground-700 text-xl md:text-2xl lg:text-3xl font-normal mt-3">
            最新电影与最新电视剧新片上映更新快
          </span>
        </h1>

        <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          汇集<strong>最新电影</strong>、<strong>最新电视剧</strong>，新片上映同步更新快。热门剧集<strong>高清免费在线观看</strong>，不缓冲流畅播放，追剧首选平台。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/movie"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-950 font-bold text-base rounded-full hover:bg-primary-400 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-movie-2-line mr-2"></i>
            最新电影
          </Link>
          <Link
            to="/category/tv"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-800 text-foreground-800 font-bold text-base rounded-full hover:bg-background-700 border border-background-700 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-tv-line mr-2"></i>
            最新电视剧
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-16">
          {[
            { num: '10万+', label: '影视资源' },
            { num: '5000万+', label: '活跃用户' },
            { num: '99.9%', label: '播放流畅率' },
            { num: '24h', label: '更新速度' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">{stat.num}</div>
              <div className="text-foreground-500 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}